// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  margin: 0;
  margin-top: 15px;
  padding: 0;
  border-radius: 0;
  --ion-background-color: var(--planeed-color-white);
}

ion-list {
  padding: 0;
  margin: 0;
}

ion-row {
  margin: 0;
}
ion-row ion-icon {
  padding: 2px 0 0 0;
}

p {
  display: inline;
}

.avatar-box {
  height: 100%;
  padding-top: 16px;
}

.social-counter {
  margin-bottom: 10px;
  color: var(--ion-color-medium);
  padding: 2px 10px 0 4px;
}

.social-counter ion-icon {
  width: 17px;
  height: 17px;
}

.social-counter span {
  margin: 0 10px 0 5px;
  font-size: 15px;
}

ion-item img {
  width: 70px;
  height: 70px;
  object-fit: cover;
  margin: 0 10px 0 0;
  border-radius: 50%;
}

h3 {
  font-size: 15px;
}

.impact-score-box ion-icon {
  background: var(--planeed-color-white);
  margin-top: -8px;
  position: absolute;
  margin-left: -12px;
  width: 26px;
  font-size: 15px;
}

.score-heading {
  text-align: center;
  color: var(--ion-color-medium);
}

.score-content-center2 {
  font-size: 17px;
  color: var(--ion-color-warning);
  text-align: center;
  padding-top: 22px;
}

.impact-score-box {
  border: 2px solid var(--ion-color-warning);
  width: 75px;
  height: 75px;
  text-align: center;
  font-size: 25px;
  position: relative;
  border-radius: 50%;
  margin: 0 auto;
}

.score-content {
  position: relative;
  margin-top: -80px;
  padding-bottom: 21px;
}

.content {
  padding: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
